import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ImageService} from "../../../data/services/image.service";
import {MessageService} from "primeng/api";
import {ImageDetail} from "../../../data/types/groups/types";
import {Button} from "primeng/button";
import {DialogModule} from "primeng/dialog";
import {EditorModule} from "primeng/editor";
import {FormsModule} from "@angular/forms";
import {UpdateImageSafetyAndCostCaptions} from "../../../data/types/groups/params";
import {GroupsService} from "../../../data/services/groups.service";
import {HttpErrorResponse} from "@angular/common/http";
import {catchError, throwError} from "rxjs";
import {InputTextModule} from "primeng/inputtext";

@Component({
  selector: 'app-safety-cost-caption-dialog',
  standalone: true,
  imports: [
    Button,
    DialogModule,
    EditorModule,
    FormsModule,
    InputTextModule
  ],
  templateUrl: './safety-cost-caption-dialog.component.html',
  styleUrl: './safety-cost-caption-dialog.component.css'
})
export class SafetyCostCaptionDialogComponent {
  @Input({required: true}) dialogVisible!: boolean;

  @Output() onVisibilityChanged = new EventEmitter<boolean>();
  @Output() onSuccess = new EventEmitter<boolean>();

  safetyCaption: string | null = null;
  costCaption: string | null = null;
  failureTerm: string | null = null;

  groupsService = inject(GroupsService);
  messageService = inject(MessageService);

  protected image: ImageDetail | undefined
  protected selectedMakeId: number | undefined


  loading = false;
  failed = false;

  setImage(image: ImageDetail) {
    this.image = image;

    this.costCaption = this.image.cost_caption
    this.safetyCaption = this.image.safety_caption
    this.failureTerm = this.image.failure_term
  }

  setSelectedMakeId(id: number) {
    this.selectedMakeId = id
  }

  updateImageSafetyAndCostCaption() {
    if (this.image === undefined || this.safetyCaption === undefined || this.costCaption === undefined) {
      return
    }

    this.loading = true;

    const params: UpdateImageSafetyAndCostCaptions = {
      sjc_id: this.image.sjc_id,
      image_id: this.image.sjc_inspection_image_id!,
      sjc_group_id: this.image.sjc_group_id!,
      make_id: this.selectedMakeId!,
      safety_caption: this.removeNonBreakingSpace(this.safetyCaption),
      failure_term: this.failureTerm,
      cost_caption: this.removeNonBreakingSpace(this.costCaption),
      sjc_group_sjc_inspection_image_id: this.image.sjc_group_sjc_inspection_image_id!
    }

    this.groupsService.updateImageSafetyAndCostCaption(params).pipe(
        catchError((error) => this.handleError(error))
    ).subscribe((response) => {
      this.loading = false;
      this.dialogVisible = false;
      this.onVisibilityChanged.emit(false);
      this.onSuccess.emit(true);
      this.messageService.add({severity: 'success', summary: 'Success', detail: 'Successfully updated safety and cost captions'});
    });
  }

  removeNonBreakingSpace(value: string | null): string | null {
    if (value === null) {
      return null
    }
    return value.replace(/&nbsp;/g, ' ');
  }

  save() {
    this.updateImageSafetyAndCostCaption()
  }

  close() {
    this.onVisibilityChanged.emit(false);
    this.dialogVisible = false;
  }

  handleError(error: HttpErrorResponse) {
    this.failed = true;
    this.loading = false;
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Failed to update caption'
    });
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}
